import moment from 'moment'
import { instance } from '../lib/api'
import Constants from '../utils/CommonConstants'
import { LOAD_COUNT_DECREMENT, LOAD_COUNT_INCREMENT } from './loading'
import getKeySearchPromises from '../utils/getKeySearchPromises'

export const API_FAIL = 'API_FAIL'
export const GET_LIST = 'GET_LIST'
export const DASHBOARD_STATS = 'DASHBOARD_STATS'
export const DASHBOARD_RESET = 'DASHBOARD_RESET'
export const PULLED_CASE = 'PULLED_CASE'
export const IS_STATUS_ONLINE = 'IS_STATUS_ONLINE'
export const EXCEL_URL = 'EXCEL_URL'

const parseDashboardResponse = (resp, keys) => {
  const dashboardResp = {}
  for (let i = 0; i < resp.length; i++) {
    dashboardResp[keys[i]] =
      resp[i] && resp[i].totalCount ? resp[i].totalCount : 0
  }
  return dashboardResp
}

const getTimeRange = filters => {
  if (!filters) return false

  let applyTimeFilter = false
  const timeRange = {}
  const { startDate, endDate } = filters
  if (startDate) {
    timeRange.from = moment(startDate).startOf('day').valueOf()
    applyTimeFilter = true
  }
  if (endDate) {
    timeRange.to = moment(endDate).endOf('day').valueOf()
    applyTimeFilter = true
  }
  return { timeRange, applyTimeFilter }
}

export const getDashboard = (agentId = null, oldFilters, keys = false) => {
  keys = keys || Constants.dashboardEntityKeys.brokerEntities
  const strSelector = selectorFromKeys(
    Constants.CaseSubTypeMap.BROKER_ORDER,
    keys,
    agentId,
    oldFilters
  )

  const promise = getKeySearchPromises(
    Constants.keySearchUrlsMap.BROKER_ORDER,
    strSelector
  )
  return dispatch => {
    return promise
      .then(response => {
        if (keys.length === 1) {
          //  listing page data
          dispatch({
            type: GET_LIST,
            data: response && response[0]
          })
        } else {
          //  dashboard data
          dispatch({
            type: DASHBOARD_STATS,
            payload: {
              filters: oldFilters,
              dashboard: parseDashboardResponse(response, keys)
            }
          })
        }
      })
      .catch(() => {
        dispatch({
          type: API_FAIL
        })
      })
  }
}

export const getExcel = (
  excelName,
  agentId = null,
  oldFilters,
  keys = false
) => {
  const strSelector = selectorFromKeys(
    oldFilters.caseSubTypeId,
    keys,
    agentId,
    oldFilters,
    true
  )
  //const excelUrl = `/mystique/rcm/v1/get-xls/${excelName}?selector=${strSelector}`;
  const excelUrl = `/mystique/rcm/v1/housing-developer-payments/key-search/rcm-payments.csv?rcmSelectorsArray=${strSelector}`
  return dispatch => {
    dispatch({
      type: EXCEL_URL,
      excelUrl
    })
  }
}

export const resetDashboard = () => {
  return dispatch => {
    dispatch({
      type: DASHBOARD_RESET
    })
  }
}

export const setStatusOnlineOffline = status => {
  return dispatch => {
    return setStatus(status)
      .then(response => {
        dispatch({
          type: IS_STATUS_ONLINE,
          isStatusOnline: !!status
        })
      })
      .catch(err => {
        dispatch({
          type: API_FAIL
        })
      })
  }
}

export const setStatus = status => {
  return instance({
    url: `/sapphire/v1/agents/status?status=${status}`,
    method: 'PUT'
  })
}

export const getOnlineStatus = isSalesRoleOnly => {
  return dispatch => {
    if (isSalesRoleOnly) {
      return dispatch({
        type: IS_STATUS_ONLINE,
        isStatusOnline: false
      })
    }
    let isStatusOnline = false
    const url = '/sapphire/v1/agents/status'
    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: 'Fetching user online status.'
    })
    return instance({
      url,
      method: 'get'
    })
      .then(response => {
        isStatusOnline = !!response.data.data.status
        dispatch({
          type: IS_STATUS_ONLINE,
          isStatusOnline
        })
      })
      .catch(err => {
        dispatch({
          type: API_FAIL
        })
        dispatch({
          type: IS_STATUS_ONLINE,
          isStatusOnline: false
        })
      })
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}

export const resetDashboardStats = () => {
  return dispatch => {
    dispatch({
      type: DASHBOARD_STATS_RESET
    })
  }
}

function selectorFromKeys(
  caseSubTypeId,
  keys,
  agentId,
  oldFilters,
  onlyTopFilter = false
) {
  const selectorArr = [],
    entities = Constants.dashboardEntities
  const paging =
    oldFilters && oldFilters.paging ? oldFilters.paging : { rows: 0 }
  keys.forEach(key => {
    const keyFilter = entities[key]
    const filters = { caseSubTypeId }

    if (keyFilter.addAsFilter) {
      const fiqlFilter = {
        and: []
      }
      if (keyFilter.useDateFilter) {
        const { timeRange, applyTimeFilter } = getTimeRange(oldFilters)
        if (applyTimeFilter) {
          const range = {}
          range[keyFilter.dateFilter] = timeRange
          fiqlFilter.and.push({ range })
        }
      }
      if (keyFilter.statusId) {
        const equal = {}
        equal.statusId = keyFilter.statusId
        fiqlFilter.and.push({ equal })
      }
      if (keyFilter.hasOwnProperty('isMigrated')) {
        if (keyFilter.isMigrated) {
          const equal = {}
          equal.isMigrated = true
          fiqlFilter.and.push({ equal })
        } else {
          const exists = {}
          exists.isMigrated = false
          fiqlFilter.and.push({ exists })
        }
      }
      if (fiqlFilter.and.length > 0) {
        filters.filters = fiqlFilter
      }
    } else if (oldFilters && keyFilter.useDateFilter) {
      const { timeRange, applyTimeFilter } = getTimeRange(oldFilters)
      if (applyTimeFilter) {
        filters.timeRange = timeRange
      }
    } else if (keyFilter.defaultTime && keyFilter.useDateFilter) {
      const { timeRange, applyTimeFilter } = getTimeRange({
        startDate: new Date(),
        endDate: new Date()
      })
      if (applyTimeFilter) {
        filters.timeRange = timeRange
      }
    }

    filters.key = keyFilter.key
    // filters.caseSubTypeId = keyFilter.caseSubTypeId;
    if (keyFilter.addAgent) {
      filters.agentId = agentId
    }

    filters.team = true
    filters.paging = paging
    selectorArr.push(filters)
  })
  return JSON.stringify(onlyTopFilter ? selectorArr.pop() : selectorArr)
}

export const getDeveloperDashboard = (
  platform,
  agentId = null,
  oldFilters,
  keys = false
) => {
  const dashboardEntities = Constants.dashboardEntityKeys[platform],
    caseSubTypeId = Constants.CaseSubTypeMap[platform]
  let key1, key2, key3
  if (keys) {
    const key = keys[0]
    let selector = selectorFromKeys(
        (dashboardEntities.paymentEntities || []).includes(key)
          ? caseSubTypeId.PAYMENTS
          : (dashboardEntities.termsheetEntities || []).includes(key)
            ? caseSubTypeId.TERMSHEET
            : caseSubTypeId.REFUND,
        keys,
        agentId,
        oldFilters
      ),
      url
    let promise = Promise.resolve([])
    if ((dashboardEntities.paymentEntities || []).includes(key)) {
      promise = getKeySearchPromises(
        Constants.keySearchUrlsMap.PAYMENTS,
        selector
      )
    } else if ((dashboardEntities.termsheetEntities || []).includes(key)) {
      promise = getKeySearchPromises(
        Constants.keySearchUrlsMap.TERMSHEET,
        selector
      )
    } else {
      promise = getKeySearchPromises(
        Constants.keySearchUrlsMap.REFUND,
        selector
      )
    }
    return dispatch => {
      return promise
        .then(response => {
          dispatch({
            type: GET_LIST,
            data: response && response[0]
          })
        })
        .catch(() => {
          dispatch({
            type: API_FAIL
          })
        })
    }
  } else {
    key1 = dashboardEntities.paymentEntities
    key2 = dashboardEntities.termsheetEntities
    key3 = dashboardEntities.refundEntities
    const selector1 = selectorFromKeys(
      caseSubTypeId.PAYMENTS,
      key1,
      agentId,
      oldFilters
    )
    const selector2 = selectorFromKeys(
      caseSubTypeId.TERMSHEET,
      key2,
      agentId,
      oldFilters
    )
    const selector3 = selectorFromKeys(
      caseSubTypeId.REFUND,
      key3,
      agentId,
      oldFilters
    )
    const paymentPromise =
      key1 && key1.length
        ? getKeySearchPromises(Constants.keySearchUrlsMap.PAYMENTS, selector1)
        : Promise.resolve([])
    const termsheetPromise =
      key2 && key2.length
        ? getKeySearchPromises(Constants.keySearchUrlsMap.TERMSHEET, selector2)
        : Promise.resolve([])
    const refundPromise =
      key3 && key3.length
        ? getKeySearchPromises(Constants.keySearchUrlsMap.REFUND, selector3)
        : Promise.resolve([])

    return dispatch => {
      return Promise.all([paymentPromise, termsheetPromise, refundPromise])
        .then(([paymentData, termsheetData, refundData]) => {
          dispatch({
            type: DASHBOARD_STATS,
            payload: {
              filters: oldFilters,
              dashboard: Object.assign(
                {},
                parseDashboardResponse(paymentData, key1),
                parseDashboardResponse(termsheetData, key2),
                parseDashboardResponse(refundData, key3)
              )
            }
          })
        })
        .catch(error => {
          dispatch({
            type: API_FAIL
          })
        })
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/dashboard.js
 **/